export default () => !window.Intl ? import('./web') : Promise.resolve() as PromiseLike<any>;
